/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopyPriceResponse
 */
export interface CopyPriceResponse {
    /**
     * 
     * @type {number}
     * @memberof CopyPriceResponse
     */
    totalProcessed: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPriceResponse
     */
    copiedCount: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPriceResponse
     */
    skippedCount: number;
    /**
     * 
     * @type {number}
     * @memberof CopyPriceResponse
     */
    errorCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopyPriceResponse
     */
    errors: Array<string>;
}

/**
 * Check if a given object implements the CopyPriceResponse interface.
 */
export function instanceOfCopyPriceResponse(value: object): value is CopyPriceResponse {
    if (!('totalProcessed' in value) || value['totalProcessed'] === undefined) return false;
    if (!('copiedCount' in value) || value['copiedCount'] === undefined) return false;
    if (!('skippedCount' in value) || value['skippedCount'] === undefined) return false;
    if (!('errorCount' in value) || value['errorCount'] === undefined) return false;
    if (!('errors' in value) || value['errors'] === undefined) return false;
    return true;
}

export function CopyPriceResponseFromJSON(json: any): CopyPriceResponse {
    return CopyPriceResponseFromJSONTyped(json, false);
}

export function CopyPriceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyPriceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalProcessed': json['totalProcessed'],
        'copiedCount': json['copiedCount'],
        'skippedCount': json['skippedCount'],
        'errorCount': json['errorCount'],
        'errors': json['errors'],
    };
}

export function CopyPriceResponseToJSON(json: any): CopyPriceResponse {
    return CopyPriceResponseToJSONTyped(json, false);
}

export function CopyPriceResponseToJSONTyped(value?: CopyPriceResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalProcessed': value['totalProcessed'],
        'copiedCount': value['copiedCount'],
        'skippedCount': value['skippedCount'],
        'errorCount': value['errorCount'],
        'errors': value['errors'],
    };
}

